import { render, staticRenderFns } from "./ProvinceList.vue?vue&type=template&id=4e46b7a4"
import script from "./ProvinceList.vue?vue&type=script&lang=js"
export * from "./ProvinceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports